import { Pinia } from '@/store/pinia-class-component';
import { Entity } from '@/models/types/Entity';

export abstract class miniEntityStore extends Pinia {
  abstract addEntity(entity: Entity): void;
  abstract deleteEntity(entity: Entity): void;
  abstract resetState(): void;
}
